module.exports = __webpack_public_path__ + "@/assets/img/notification.69250612.svg";